import { AxiosResponse } from 'axios';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

import {
  IDataUploadGetSchemaResponse,
  IDataUploadGetLinkResponse,
  IDataUploadSubmitData,
  IDataUploadSubmitResponse,
  GetFieldTempleteDataUploadResponse,
  CreateFieldTempleteDataUploadRequest,
  CreateFieldTempleteDataUploadResponse,
  UpdateFieldTempleteDataUploadRequest,
  UpdateFieldTempleteDataUploadResponse,
  DeleteFieldTempleteDataUploadResponse,
} from 'models/http/data-upload';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { DataUploadModels } from 'utils/enums/model-names';
import { serverAxios } from 'utils/http';

abstract class DataUploadBaseHttp {
  private readonly dataUploadRoute = 'data-upload';
  protected abstract readonly route: DataUploadModels;

  public async dataUploadGetLink(abortController?: AbortController): Promise<IDataUploadGetLinkResponse> {
    return serverAxios
      .get(`/${this.route}/${this.dataUploadRoute}/link`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IDataUploadGetLinkResponse>) => {
        return response.data;
      });
  }

  public async dataUploadSubmit(data: IDataUploadSubmitData, abortController?: AbortController): Promise<number> {
    return serverAxios
      .post(`/${this.route}/${this.dataUploadRoute}/submit`, data, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IDataUploadSubmitResponse>) => {
        return response.data.id;
      });
  }

  public async dataUploadGetFieldsMapping(abortController?: AbortController): Promise<IDataUploadGetSchemaResponse> {
    return serverAxios
      .get(`/${this.route}/${this.dataUploadRoute}/schema`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IDataUploadGetSchemaResponse>) => {
        return response.data;
      });
  }

  public async getFieldTemplatesSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/${this.dataUploadRoute}/templates/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async getFieldTemplateById(id: number, abortController?: AbortController): Promise<GetFieldTempleteDataUploadResponse> {
    return serverAxios
      .get(`/${this.route}/${this.dataUploadRoute}/templates/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<GetFieldTempleteDataUploadResponse>) => {
        return response.data;
      });
  }

  public async createFieldTemplate(data: CreateFieldTempleteDataUploadRequest): Promise<CreateFieldTempleteDataUploadResponse> {
    return serverAxios
      .post(`/${this.route}/${this.dataUploadRoute}/templates`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<CreateFieldTempleteDataUploadResponse>) => {
        return response.data;
      });
  }

  public async updateFieldTemplate(id: number, data: UpdateFieldTempleteDataUploadRequest): Promise<UpdateFieldTempleteDataUploadResponse> {
    return serverAxios
      .patch(`/${this.route}/${this.dataUploadRoute}/templates/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<UpdateFieldTempleteDataUploadResponse>) => {
        return response.data;
      });
  }

  public async deleteFieldTemplate(id: number): Promise<DeleteFieldTempleteDataUploadResponse> {
    return serverAxios
      .delete(`/${this.route}/${this.dataUploadRoute}/templates/${id}`, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<DeleteFieldTempleteDataUploadResponse>) => {
        return response.data;
      });
  }
}

export default DataUploadBaseHttp;
